










import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import AppDatatable from '@core/components/AppDatatableV2.vue'
import AppForm from '@core/components/AppForm.vue'
import { FormStructure } from '@master/model/structure/FormStructure'
import { NBRStatusOptions } from '@master/model/options/NBRStatusOptions'
import { ClientPolicySearchDTO } from '../../api'
import { ReconReportSearchCriteria } from './model/ReconReportDTO'
import { options } from '@master/model/options/Options'

@Component({
  components: {
    AppDatatable,
    AppForm
  }
})
export default class PolicyDashboardComponent extends Vue {
  @Prop({ default: () => [] }) companyOptions: options[]
  @Prop({ default: () => [] }) adviserOptions: options[]

  filterModel: ReconReportSearchCriteria = new ReconReportSearchCriteria()

  get preSelectStructure (): FormStructure<ReconReportSearchCriteria> {
    return [
      {
        label: 'Report Selection',
        key: 'currentPreselectedReport',
        options: [
          { value: '', label: '' },
          {
            value: 'productionYTD', label: 'Production Year to Date'
          }
        ]
      }
    ]
  }

  get filterStructure (): FormStructure<ClientPolicySearchDTO> {
    return [
      {
        label: 'Company',
        key: 'principalOids',
        options: this.companyOptions,
        type: 'multi'
      },
      {
        label: 'Advisers',
        key: 'adviserOids',
        options: this.adviserOptions,
        type: 'multi'
      },
      {
        label: 'Status',
        key: 'status',
        options: NBRStatusOptions,
        type: 'smart',
        multiple: true
      },
      {
        label: 'Ops Approval Start Date',
        key: 'opsApprovalStartDate',
        type: 'date'
      },
      {
        label: 'Ops Approval End Date',
        key: 'opsApprovalEndDate',
        type: 'date'
      },
      {
        label: 'NBR Created Start Date',
        key: 'creationStartDate',
        type: 'date'
      },
      {
        label: 'NBR Created End Date',
        key: 'creationEndDate',
        type: 'date'
      }
    ]
  }

  @Watch('filterModel.currentPreselectedReport')
  prefillCriteria () {
    this.filterModel.prefillSearchCriteria()
  }
}
